<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 左侧主要内容 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --steps">
          <div class="widjet__head">
            <h3 class="uk-text-lead">使用教程</h3>
          </div>
          <div class="widjet__body">
            <div class="guide-section">
              <!-- 1. 下载客户端 -->
              <div class="section">
                <h1 class="section-title">📥 下载客户端</h1>
                <p class="step">
                  <a href="https://study.s3.bitiful.net/ClashX.dmg" class="download-btn">【点击下载】</a>
                </p>
                <img src="@/assets/img/20240919131026ujZN.jpg" alt="下载客户端" class="guide-img" />
              </div>

              <!-- 2. 官网兑换优惠券码 -->
              <div class="section">
                <h1 class="section-title">🎟️ 官网兑换优惠券码</h1>
                <p class="info-text">先在官网注册账号（账号独立使用，稳定、安全）。</p>
                <p>
                  <strong>官网①：</strong>
                  <a href="https://ok.realsulian.com/" target="_blank" class="faq-link">https://ok.realsulian.com</a>
                </p>
                <p>
                  <strong>备用官网②：</strong>
                  <a href="https://47.100.224.79/" target="_blank" class="faq-link">点我查看</a>
                </p>
                <img src="@/assets/img/20240919130607ixRc.jpg" alt="官网兑换优惠券码" class="guide-img" />
              </div>

              <!-- 3. 官网导入URL订阅 -->
              <div class="section">
                <h1 class="section-title">🔗 官网导入 URL 订阅</h1>
                <p class="info-text">
                  <a href="https://ok.realsulian.com" target="_blank" class="faq-link">点击获取订阅链接</a>
                </p>
                <p class="info-text">以下为手动导入教程：</p>
                <img src="@/assets/img/20240919130622LhYG.jpg" alt="手动导入教程" class="guide-img" />
                <img src="@/assets/img/20240919130625bAnC.jpg" alt="手动导入步骤" class="guide-img" />
              </div>

              <!-- 4. 打开开关 连接网络 -->
              <div class="section">
                <h1 class="section-title">🌐 打开开关 连接网络</h1>
                <img src="@/assets/img/20240919130627cxCJ.jpg" alt="连接网络" class="guide-img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加信息 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">测试 & 常见问题</h3>
          </div>
          <div class="widjet__body">
            <p class="support-text">
              <strong>点</strong>
              <a href="http://google.com/" target="_blank" class="test-link">google.com</a>
              打开网址测试，能使用说明线路连接成功，开始快乐看世界~
            </p>
            <img src="@/assets/img/20240919130630Ohif.jpg" alt="测试示例" class="guide-img" />

            <h3 class="faq-title">🚀 TikTok 用不了？</h3>
            <p>TikTok 对国区有限制，建议参考以下解决方案：</p>
            <ul class="faq-list">
              <li>1. **拔掉手机卡**（插上就无法观看）</li>
              <li>2. 手机设置 → **语言与地区** → **改为美国**</li>
              <li>3. 选择 **美国线路 1~10**</li>
              <li>4. **重启设备**，连接节点，成功进入 TikTok</li>
              <li>5. **推荐直接访问**：
                <a href="https://www.tiktok.com/" target="_blank" class="faq-link">www.tiktok.com</a>
              </li>
            </ul>

            <h3 class="faq-title">🤖 ChatGPT 用不了？</h3>
            <p>选择 **带 GPT 字样的美国线路**，然后 **关闭浏览器或 APP 重新进入**。</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "UserGuide",
};
</script>

<style scoped>
/* 🌟 页面整体布局 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 标题样式 */
.section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #ddd;
}

.section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 下载按钮 */
.download-btn {
  display: inline-block;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: rgb(192, 0, 0);
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;
}

.download-btn:hover {
  background-color: rgb(150, 0, 0);
}

/* 🌟 图片样式 */
.guide-img {
  width: 100%;
  max-width: 900px;
  height: auto;
  margin: 15px 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* 🌟 常见问题 */
.faq-title {
  font-size: 18px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-top: 20px;
}

.faq-link {
  color: rgb(0, 112, 192);
  text-decoration: none;
}

.faq-link:hover {
  text-decoration: underline;
}
</style>
